import React, { Component } from 'react';

// components
import { FiltersTitle } from '/src/pages/directories/filters';
import EstimationIndicator from '../../../components/Reusable/EstimationIndicator';



export default class DirectoryFilters extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        const { user, directory, showLegend = false } = this.props;

        // hide filters if user is logged out and data is hidden
        const dir_login_only = ["funds", 'private-equity'];
        if (!user.is_loggedin && dir_login_only.includes(directory)) {
            return (null);
        }

        // display filters btn
        else {
            return (
                <div className="directory-filters filters">
                    <FiltersTitle props={this.props} />
                    {this.props.children}
                    {showLegend && (
                        <EstimationIndicator/>
                    )}
                </div>
            )
        }
    }
}
